import Order, { OrderColumns } from 'communication/types/order/Order';

export interface OrdersState {
    data?: Order[];
    streamKey?: string;
    streamingColumns: OrderColumns;
    streamingOrderIds: string[];
    batchUpdateInProgress: boolean;
    firstBatchComplete: boolean;
}

export const initialOrdersState: OrdersState = {
    streamingColumns: [],
    streamingOrderIds: [],
    batchUpdateInProgress: true,
    firstBatchComplete: false,
};
